export interface IServices extends Record<symbol, unknown> {

}

export const Services = {} as IServices;

export default Services;

